import { IOption } from '../Interface/Interface';

export const getOptionLabel = (option: IOption | undefined) => {
  let label = '';
  if (option) {
    label = option.title;
    const amount = option.amount;
    if (amount > 1) {
      label = `${amount}x ${label}`;
    }
  }
  return label;
};
